<template>
  <div class="ddddd" style="height: 100%; color: #c7ddfb">
    <div class="heardT">
      <div style="width: 100%">
        <div class="heardT-left">充电管理平台</div>
        <div class="heardT-center">
          <ul>
            <!-- <li class="on"><span style="color: #00e4fe">区域选择</span>/</li>
            <li @click="internet('dataMap', 'device')">
              <span>消防物联网</span>/
            </li> -->
            <!-- <li @click="internet('firefighting', 'project-management')">
              <span>消防管理</span>/
            </li>
            <li @click="internet('system', 'user-management')" class="ddc">
              <span>系统设置</span>/
            </li> -->
          </ul>
        </div>
        <div class="heardT-right">
          <img
            src="../../static/image/head.jpg"
            title="密码修改"
            class="avatar"
            @click="handleEdit()"
            style="
              border-radius: 50%;
              height: 1.25rem;
              width: 1.25rem;
              cursor: pointer;
              margin-right: 1.05rem;
              display: none;
            "
          />
          <span @click="handleEdit()">{{ name }}</span>
          <img
            @click="eqit()"
            style="
              width: 1.4rem;
              height: 1.4rem;
              margin-right: 0.5rem;
              margin-left: 0.5rem;
              cursor: pointer;
            "
            src="../../static/image/back.png"
            alt="返回首页"
          />
        </div>
      </div>
      <!-- 搜索 -->
      <div class="searchPro">
        <el-input
          placeholder="请输入充电桩名称"
          class="T-center-input"
          v-model="searchProject"
        >
          <i
            class="el-icon-search el-input__icon"
            slot="suffix"
            @click="handleIconClick"
          >
          </i>
        </el-input>
        <div
          class="projectSarchList"
          v-if="projectSarchListHidden"
          :class="Projectoptions.length > 5 ? 'projectList5' : ''"
        >
          <p
            v-for="item in Projectoptions"
            @click="search(item)"
            :key="item.id"
          >
            {{ item.name }}
          </p>
        </div>
      </div>
    </div>
    <div class="bodyLeft">
      <div>
        <p>{{dataInfo.deviceCount}}</p>
        <p>总设备数量</p>
      </div>
      <div>
        <p style="color: #43fc84">{{ dataInfo.sumUserCount }}</p>
        <p>总用户数量</p>
      </div>
      <div>
        <p style="color: #3692ff">{{dataInfo.totalOrderCount}}</p>
        <p>总订单数量</p>
      </div>
      <div>
        <p style="color: #fc633a">{{
              dataInfo.totalOrderCharge == null
                ? 0
                : (dataInfo.totalOrderCharge / 100).toFixed(1)
            }}</p>
        <p>总流水金额</p>
      </div>
     
    </div>
    <div class="bodyRight">
      <div style="text-align:center;margin-bottom:15px">流水金额</div>
      <div class="body-R-num">
        <div>
          <p>前一天</p>
          <p>{{(dataInfo2.income / 100).toFixed(2)}}</p>
        </div>
        <div>
          <p>当天</p>
          <p style="color: #fc552a">{{
              dataInfo.todayIncome == null
                ? 0
                : (dataInfo.todayIncome / 100).toFixed(2)
            }}</p>
        </div>
      </div>
      <div class="body-R-all"></div>
      <div style="text-align:center;margin-top:10px;margin-bottom:0px">前一天流水占比</div>
      <div class="body-R-percentage">

        <div style="color: #fc552a">
          <p><span>微信流水</span><span>{{dataInfo2.wechatOrderCount==0?0:((dataInfo2.wechatOrderCount/beforeallNum)*100).toFixed(2)}}%</span></p>
          
          <el-progress
            :show-text="false"
            :stroke-width="10"
            :percentage="dataInfo2.wechatOrderCount==0?0:((dataInfo2.wechatOrderCount/beforeallNum)*100).toFixed(2)"
            color="rgba(252,85,42,0.8)"
          ></el-progress>
        </div>
        <div style="color: #01e2d4">
          <p><span>支付宝流水</span><span>{{dataInfo2.alipayOrderCount==0?0: ((dataInfo2.alipayOrderCount/beforeallNum)*100).toFixed(2)}}%</span></p>
         
          <el-progress
            :show-text="false"
            :stroke-width="10"
            :percentage="dataInfo2.alipayOrderCount==0?0: ((dataInfo2.alipayOrderCount/beforeallNum)*100).toFixed(2)"
            color="rgba(1,226,212,0.8)"
          ></el-progress>
        </div>
        <div style="color: #d39848">
          <p><span>实体卡流水</span><span>{{dataInfo2.cardOrderCount==0?0: ((dataInfo2.cardOrderCount/beforeallNum)*100).toFixed(2)}}%</span></p>
          <el-progress
            :show-text="false"
            :stroke-width="10"
            :percentage="dataInfo2.cardOrderCount==0?0: ((dataInfo2.cardOrderCount/beforeallNum)*100).toFixed(2)"
            color="rgba(211,152,72,0.8)"
          ></el-progress>
        </div>
        <div style="color: #b887ff">
          <p><span>先享后付流水</span><span>{{dataInfo2.virtualCardOrderCount==0?0: ((dataInfo2.virtualCardOrderCount/beforeallNum)*100).toFixed(2)}}%</span></p>
          <el-progress
            :show-text="false"
            :stroke-width="10"
            :percentage="dataInfo2.virtualCardOrderCount==0?0: ((dataInfo2.virtualCardOrderCount/beforeallNum)*100).toFixed(2)"
            color="rgba(184,135,255,0.8)"
          ></el-progress>
        </div>
      </div>
    </div>
    <div class="bottomT">
      <div class="bottom-general-situation">
        <span>营收统计</span>
        <ul class="bottom-general-situation-div">
          <li @click="general(0)" :class="current == 0 ? 'active' : ''">
            充电订单
          </li>
          <li @click="general(1)" :class="current == 1 ? 'active' : ''">
            流水金额
          </li>
          <li @click="general(2)" :class="current == 2 ? 'active' : ''">
            耗电量
          </li>
          <li @click="general(3)" :class="current == 3 ? 'active' : ''">
            充电用户
          </li>
        </ul>
        <div class="general-situation"></div>
      </div>
      <div class="bottom-property-management">
        <span>设备状态</span>
        <!-- <ul class="management-title">
          <li
            @click="property(0)"
            :class="propertycurrent == 0 ? 'active' : ''"
          >
            巡检记录
          </li>
          <li
            @click="property(1)"
            :class="propertycurrent == 1 ? 'active' : ''"
          >
            维保工作
          </li>
          <li
            @click="property(2)"
            :class="propertycurrent == 2 ? 'active' : ''"
          >
            维修服务
          </li>
        </ul> -->
        <div class="routing-inspection" style="margin-top: 30px;">
          <p>设备在线数</p>
          <ul class="bars-container">
            <li
              v-for="(item, index) in 90"
              :key="index"
              class="bar"
              :style="
                item * xjz < xj / 2
                  ? 'background:rgba(53, 235, 255, 0.8)'
                  : item * xjz > xj
                  ? 'background:rgba(66, 89, 120, 0.4)'
                  : 'background:rgba(67,144,250,0.9)'
              "
            ></li>
          </ul>
          <span class="inspection-number">{{ xj }}</span>
          <!-- <span class="inspection-percentage">0.15%</span>
          <span class="inspection-rise"
            ><i
              class="el-icon-top"
              style="color: #02fea7; font-weight: bold"
            ></i
          ></span> -->
        </div>
        <div class="routing-inspection">
          <p>设备离线数</p>
          <ul  class="bars-container">
            <li
              v-for="(item, index) in 90"
              :key="index"
              class="bar"
              :style="
                item * rwz < rw / 2
                  ? 'background:rgba(249, 76, 53, 0.8)'
                  : item * rwz > rw
                  ? 'background:rgba(66, 89, 120, 0.4)'
                  : 'background:rgba(249,109,109,0.6)'
              "
            ></li>
          </ul>
          <span class="inspection-number">{{ rw }}</span>
          <!-- <span class="inspection-percentage" style="color: #f93936"
            >3.15%</span
          >
          <span class="inspection-rise"
            ><i
              class="el-icon-bottom"
              style="color: #f93936; font-weight: bold"
            ></i
          ></span> -->
        </div>
        <div class="routing-inspection">
          <p>端口使用数</p>
          <ul   class="bars-container">
            <li
              v-for="(item, index) in 90"
              :key="index"
              class="bar"
              :style="
                item * csz < cs / 2
                  ? 'background:rgba(53, 235, 255, 0.8)'
                  : item * csz > cs
                  ? 'background:rgba(66, 89, 120, 0.4)'
                  : 'background:rgba(67,144,250,0.9)'
              "
            ></li>
          </ul>
          <span class="inspection-number">{{ cs }}</span>
          <!-- <span class="inspection-percentage">0.15%</span>
          <span class="inspection-rise"
            ><i
              class="el-icon-top"
              style="color: #02fea7; font-weight: bold"
            ></i
          ></span> -->
        </div>
        <div class="routing-inspection">
          <p>端口空闲数</p>
          <ul   class="bars-container">
            <li
              v-for="(item, index) in 90"
              :key="index"
              class="bar"
              :style="
                item * wcz < wc / 2
                  ? 'background:rgba(53, 235, 255, 0.8)'
                  : item * wcz > wc
                  ? 'background:rgba(66, 89, 120, 0.4)'
                  : 'background:rgba(67,144,250,0.9)'
              "
            ></li>
          </ul>
          <span class="inspection-number">{{ wc }}</span>
          <!-- <span class="inspection-percentage">0.15%</span>
          <span class="inspection-rise"
            ><i
              class="el-icon-top"
              style="color: #02fea7; font-weight: bold"
            ></i
          ></span> -->
        </div>
      </div>
      <div class="alarm bottom-general-situation">
        <span>充电排行</span>
        <ul class="bottom-general-situation-div">
          <li @click="charge(0)" :class="chargeIndex == 0 ? 'active' : ''">
            近七日使用率
          </li>
          <li @click="charge(1)" :class="chargeIndex == 1 ? 'active' : ''">
            近七日客单价
          </li>
          <li @click="charge(2)" :class="chargeIndex == 2 ? 'active' : ''">
            近七日收入
          </li>
          
        </ul>
        <div class="alarm-list">
          <ul v-if="chargeIndex == 0">
            <li  v-for="(item, index) in usageList"
              :key="index">
              <span :style="index == 0 ? 'color: #fef100' : index == 1 ? 'color: #c0dcdc' :  index == 2 ? 'color: #cea872' : ''">TOP{{index+1}}</span>
              <span>{{item.name}}</span>
              <span> {{ (item.statUsageRate * 100).toFixed(1) }}% </span>
            </li>
           
          </ul>
          <ul v-if="chargeIndex == 1">
            <li  v-for="(item, index) in arpuRankList"
              :key="index">
              <span :style="index == 0 ? 'color: #fef100' : index == 1 ? 'color: #c0dcdc' :  index == 2 ? 'color: #cea872' : ''">TOP{{index+1}}</span>
              <span>{{item.name}}</span>
              <span> {{ (item.statArpu / 100).toFixed(2) }}元/单 </span>
            </li>
           
          </ul>
          <ul v-if="chargeIndex == 2">
            <li  v-for="(item, index) in incomeRankList"
              :key="index">
              <span :style="index == 0 ? 'color: #fef100' : index == 1 ? 'color: #c0dcdc' :  index == 2 ? 'color: #cea872' : ''">TOP{{index+1}}</span>
              <span>{{item.name}}</span>
              <span> {{  item.statIncome==null?'0.00':(item.statIncome/100).toFixed(2)}} 元 </span>
            </li>
           
          </ul>
        </div>
      </div>
    </div>
    <div class="map-info">
      <p>
        <img
          style="width: 20px; float: left; margin-right: 5px"
          src="../../static/image/home1_14.png"
          alt=""
        /><span>{{ choosemap.fireProject.projectName }}</span>
        <img
          style="width: 16px; float: right; margin-top: 2px"
          @click="closeMap()"
          src="../../static/image/home1_16.png"
          alt=""
        />
      </p>
      <div>
        <p>项目ID:{{ choosemap.fireProject.projectId }}</p>
        <p>地址:{{ choosemap.fireProject.projectAddress }}</p>
        <p>负责人:{{ choosemap.fireProject.projectResponsibilityName }}</p>
        <p>电话:{{ choosemap.fireProject.projectResponsibilityPhone }}</p>
      </div>
    </div>
    <div class="map-info-danger">
      <div>
        <img
          style="
            width: 12px;
            float: right;
            position: absolute;
            top: 16px;
            right: 16px;
          "
          @click="closeMapDanger()"
          src="../../static/image/home1_17.png"
          alt=""
        />
        <p>项目名称:{{ choosemap.fireProject.projectName }}</p>
        <p>项目ID:{{ choosemap.fireProject.projectId }}</p>
      </div>
    </div>
    <div id="container" style="width: 100%; height: 100%"></div>
    <!-- 弹窗界面 -->
    <el-dialog
      :title="title"
      :visible.sync="editFormVisible"
      top="10%"
      width="90%"
      close="userdetails"
      @click="closeDialog('editForm')"
    >
      <div class="details-right" style="float: left">
        <img
          src="../../static/image/jisoo2.jpg"
          style="width: 200px; height: 250px"
          alt=""
        />
      </div>
      <el-form :model="editForm" ref="editForm">
        <div class="details-left">
          <div>
            <span>用户账号:</span>
            <span> {{ editForm.userName }}</span>
            <span>账号id:</span>
            <span style="border: none"> {{ editForm.userId }}</span>
          </div>
          <div>
            <span>所属单位:</span>
            <span>{{ editForm.companyName }}</span>
            <span>账号地址:</span>
            <span style="border: none">{{ editForm.userAddress }}</span>
          </div>
          <div>
            <span>账户手机号:</span>
            <span>{{ editForm.userPhone }}</span>
            <span>有效时间:</span>
            <span style="border: none">{{
              editForm.termTime | timestampToTime
            }}</span>
          </div>
          <div style="border: none">
            <span>账号状态:</span>
            <span>{{ editForm.status == 0 ? "正常" : "禁用" }}</span>
            <span>角色</span>
            <span style="border: none"
              >{{ editForm.roleId }}:{{ editForm.roleName }}</span
            >
          </div>
        </div>
        <el-form-item label="">
          <div style="text-align: center; margin-top: 20px">
            <el-button
              size="mini"
              type="danger"
              @click="handleEdit02()"
              style="background-color: #378ee8; border-color: #378ee8"
              >更改密码</el-button
            >
            <el-button
              size="mini"
              type="danger"
              @click="exit()"
              style="background-color: red; border-color: red"
              >注销登录</el-button
            >
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      :title="'更改密码'"
      :visible.sync="editFormVisible02"
      width="50%"
      @click="closeDialog02()"
    >
      <el-form label-width="120px" ref="addFormInline" :model="addFormInline">
        <el-form-item label="*旧密码：" prop="old_password">
          <el-input
            size="small"
            type="password"
            v-model="addFormInline.old_password"
            auto-complete="off"
            placeholder="请输入用户旧密码"
          ></el-input>
        </el-form-item>
        <el-form-item label="*新密码：" prop="new_password">
          <el-input
            size="small"
            type="password"
            v-model="addFormInline.new_password"
            auto-complete="off"
            placeholder="请输入用户新密码"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog02()">取消</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="loading"
          class="title"
          @click="editPassword()"
          >保存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  getHomePage,
  getUsageRankPage,
  getArpuRankPage,
  getIncomeRankPage, 
  getIncomeStatRecord,
  getChargePileDeviceListEase,
  getChargePileStationListEase
} from "../api/userMG";
export default {
  data() {
    return {
      name:'',
      chargeIndex:0,
      dataInfo:{},
      searchinput: "",
      searchProject: "", //搜索的字段
      projectSarchListHidden: false, //搜索后的列表可见
      Projectoptions: "", //搜索后的列表
      mapdanger: false,
      choosemap: {
        fireProject: {
          projectName: "",
        },
      },
      loading: false, //是显示加载
      user: {},
      realTime1: "2022年 10月10日 周一",
      realTime2: "14:06",
      editFormVisible: false, //控制编辑页面显示与隐藏
      editFormVisible02: false,
      collapsed: true,
      title: "个人中心",
      editForm: {
        userId: "",
        roleId: "",
        userName: "",
        nickName: "",
        userType: "",
        email: "",
        phonenumber: "",
        status: "",
        remark: "",
        userAddress: "",
        termTime: "",
      },
      addFormInline: {
        old_password: "",
        new_password: "",
        userId: "",
      },
      xj: 0,
      xjz: 1,
      rw: 0,
      rwz: 1,
      cs: 0,
      csz: 1,
      wc: 0,
      wcz: 1,
      //地图的点
      mapMakers: [], //离线
      alarmMakers: [], //报警
      onlineMakers: [], //在线,
      map: "",
      count: 1,
      current: 0,
      alarmData: [120, 132, 101, 134, 90, 230, 210],
      faultdata: [220, 182, 191, 234, 290, 330, 310],
      propertycurrent: "0",
      //排行榜
      usageList: [],
      usageForm: {
        pageNo: 1,
        pageSize: 10,
      },
      arpuRankList: [],
      arpuRankForm: {
        pageNo: 1,
        pageSize: 10,
      },
      incomeRankList: [],
      incomeRankForm: {
        pageNo: 1,
        pageSize: 10,
      },
      //流水金额
      statisticsForm: {
        zoneId: "",
        stationId: "",
        deviceId: "",
        type: 1,
        countDate: "",
      },
      dataInfo2:{},
      beforeallNum:'',
      deviceForm:{
        pageNo: 1,
        pageSize: 10,
        queryContent:'',
        status:''
      },
      stationForm:{
        pageNo: 1,
        pageSize: 10,
        name:''
      }
    };
  },
  created() {
    this.name=localStorage.getItem("username")
    // this.user = JSON.parse(localStorage.getItem("userdata"));
    this.start();
    // this.init();
  },
  mounted() {
    this.getChargePileDeviceListEase()
    this.getHomePage();
    this.getChargePileStationListEase()
    //流水金额
    let currentDate = new Date();
    currentDate.setDate(currentDate.getDate() - 1); // ← 减一天
    this.time = currentDate;
    const date = new Date(currentDate);
    if (date < new Date(new Date().setHours(0,0,0,0))) {
        date.setDate(date.getDate() + 1);
    }

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const startTime = `${year}-${month}-${day} 00:00:00`;
    const endTime = `${year}-${month}-${day} 23:59:59`;

    const day1 = String(date.getDate()-1).padStart(2, "0");
    const startTime1 = `${year}-${month}-${day1} 00:00:00`;
    const endTime1 = `${year}-${month}-${day1} 23:59:59`;
    // this.statisticsForm.countDate = ;
    
    this.getIncomeStatRecord(startTime + "," + endTime,startTime1 + "," + endTime1);
   
    //排行榜
    this.getUsageRankPage()
    this.getGeneral();

    // this.getMapDataLngLat();

    // this.updateLayout();
  },
  methods: {
    getChargePileStationListEase(){
      getChargePileStationListEase(this.stationForm).then((res) => {
        this.onlineMakers = res.data.list;
        this.init();
      });
    },
    getChargePileDeviceListEase(){
      this.deviceForm.status=1
      getChargePileDeviceListEase(this.deviceForm).then((res) => {
        console.log('==================1111',res.data.list)
        this.onlineMakers = res.data.list;
        this.init();
      });
    },
    //流水金额
    getIncomeStatRecord(time,time2) {
      this.statisticsForm.countDate = time;
      getIncomeStatRecord(this.statisticsForm).then((res) => {
        if(res.data!=null){
          this.dataInfo2 = res.data;
          const beforeallNum=res.data.wechatOrderCount+res.data.alipayOrderCount+res.data.virtualCardOrderCount+res.data.cardOrderCount
          this.beforeallNum=beforeallNum
          this.getIncomeStatRecord1(time2);
        }else{
          this.getAll(0);
          this.beforeallNum = 0;
          this.dataInfo2={
        energyConsumed: 0,
        income: 0,
        orderCount: 0,
        rechargeIncome: 0,
        scanCodeIncome: 0,
        userCount: 0,
        wechatOrderCount: 0,
        alipayOrderCount: 0,
        virtualCardOrderCount: 0,
        cardOrderCount: 0,
      }
        }
        
      });
    },
    getIncomeStatRecord1(time) {
      this.statisticsForm.countDate = time;
      getIncomeStatRecord(this.statisticsForm).then((res) => {
        if(res.data!=null){
          this.calculateGrowthRate( this.dataInfo2.income/100,res.data.income/100)
        }else{
          this.getAll(0);
        }

      
      });
    },
    calculateGrowthRate(current, previous) {
      console.log(current, previous)
      const num=(((current - previous) / previous) * 100).toFixed(2)
      this.getAll(num);

    },
    charge(index){
      this.chargeIndex=index
      if(index==0){
        this.getUsageRankPage()
      }else if(index==1){
        this.getArpuRankPage()
      }else if(index==2){
        this.getIncomeRankPage()
      }
    },
    //排行榜
    getUsageRankPage() {
      getUsageRankPage(this.usageForm).then((res) => {
        this.usageList = res.data.list;
      });
    },
    getArpuRankPage() {
      getArpuRankPage(this.arpuRankForm).then((res) => {
        this.arpuRankList = res.data.list;
      });
    },
    getIncomeRankPage() {
      getIncomeRankPage(this.incomeRankForm).then((res) => {
        this.incomeRankList = res.data.list;
      });
    },
    //获取总体数据
    getHomePage() {
      getHomePage().then((res) => {
        this.dataInfo = res.data;
        this.xj=res.data.deviceOnlineCount
        this.rw=res.data.deviceOfflineCount
        this.cs=res.data.deviceUsingCount
        this.wc=res.data.deviceIdleCount
        this.getInspectionRecord();
      });
    },
    updateLayout() {
      const containerWidth = this.$el.offsetWidth;
      const itemCount = this.items.length;
      const itemWidth = containerWidth / itemCount;
      this.itemWidth = itemWidth;
    },
    //设备概况
    general(item) {
      this.current = item;
      console.log(item);
      if (item == 0) {
        this.alarmData = [120, 132, 101, 134, 90, 230, 210];
        this.faultdata = [220, 182, 191, 234, 290, 330, 310];
      }
      if (item == 1) {
        this.alarmData = [150, 160, 102, 50, 63, 45, 160];
        this.faultdata = [180, 190, 211, 254, 280, 230, 210];
      }
      if (item == 2) {
        this.alarmData = [50, 90, 150, 110, 105, 100, 130];
        this.faultdata = [112, 160, 200, 160, 150, 130, 180];
      }
      if (item == 3) {
        this.alarmData = [90, 150, 160, 155, 140, 120, 100];
        this.faultdata = [150, 180, 200, 190, 150, 220, 200];
      }
      this.getGeneral();
    },
    //物管考评
    property(item) {
      this.propertycurrent = item;
      if (item == 1) {
        this.xj = 10;
        this.rw = 205;
        this.cs = 188;
        this.wc = 55;
      } else if (item == 0) {
        this.xj = 3;
        this.rw = 362;
        this.cs = 322;
        this.wc = 65;
      } else if (item == 2) {
        this.xj = 15;
        this.rw = 222;
        this.cs = 399;
        this.wc = 88;
      }
    },
    handleIconClick() {
      console.log("111111111111", this.searchProject);
      // mapDataLngLatMap(this.searchProject).then((res) => {
      //   var a = [];
      //   a = res.data.offlineData
      //     .concat(res.data.alarmData)
      //     .concat(res.data.onlineData);
      //   this.Projectoptions = a;
      //   this.projectSarchListHidden = true;
      // });
     
      this.stationForm.name=this.searchProject
      getChargePileStationListEase(this.stationForm).then((res) => {
        this.Projectoptions = res.data.list;
        this.projectSarchListHidden = true;
      });
    },
    search(value) {
    
      var divElement = document.querySelector(".map-info");
      if (divElement.style.display == "blcok") {
        divElement.style.display = "none";
      }
      this.searchProject = value.name;
      this.projectSarchListHidden = false;
      var that = this;
      that.map.centerAndZoom(
        new BMapGL.Point(value.lng, value.lat),
        20
      );
      let myIcon = "";
      if(value.deviceOfflineCount>0){
          myIcon = new BMapGL.Icon(
          "../../static/image/home1_12.png",
            new BMapGL.Size(25, 35)
          );
        }else{
          myIcon = new BMapGL.Icon(
          "../../static/image/home1_11.png",
          new BMapGL.Size(20, 29)
        );
        }


      let pt = new BMapGL.Point(value.lng, value.lat);
      let marker = new BMapGL.Marker(pt, {
        icon: myIcon,
      });
      that.map.addOverlay(marker);
        let opts = {
          width: 450,
          height: 230,
        };
        let infoWindow = "";
        let sContent = ``;
      marker.addEventListener("click", function (e) {
        
        setTimeout(() => {

          that.choosemap = value;
          sContent =
          `<div><div style="font-weight:bold;font-size:13.5px;color:white;"><img
          style="width: 20px; float: left; margin-right: 10px" src="../../static/image/map1.png" alt=""/>` +
          `<span style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;color:white;display:inline-block;width:65%;font-size:15.5px">` +  
          that.choosemap.name +
          `</span>` +
          `<span style="float:right;margin-right:10px;font-size:15.5px">今日营收:` + 
          (that.choosemap.todayIncome === null ? '0元' : (that.choosemap.todayIncome/100).toFixed(1) + '元') + 
          `</span>` +
          `</div>` +
            `<p style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;color:white;">
              <img style="width: 18px; float: left;margin-right:5px" src="../../static/image/map2.png" alt=""/>` +
            that.choosemap.address +
            `</p>` +
            `<p style="color:white;font-size:15.5px;"> <img style="width: 18px; float: left;margin-right:5px" src="../../static/image/map5.png" alt=""/>设备统计</p>` +
            `<div style="display: flex; justify-content: space-between; flex-wrap: wrap; width: 99%;margin-left:1%">
<div style="width: 32%; margin-bottom: 10px;">
  <p style="color: white; font-size: 13px; margin: 0;">设备总数</p>
  <p style="color: #00e4fe; font-size: 15.5px; margin: 0; font-weight: bold;">` + (that.choosemap.deviceCount || 0) + `</p>
</div>
<div style="width: 32%; margin-bottom: 10px;">
  <p style="color: white; font-size: 13px; margin: 0;">在线设备</p>
  <p style="color: #00e4fe; font-size: 15.5px; margin: 0; font-weight: bold;">` + (that.choosemap.deviceOnlineCount || 0) + `</p>
</div>
<div style="width: 32%; margin-bottom: 10px;">
  <p style="color: white; font-size: 13px; margin: 0;">离线设备</p>
  <p style="color: red; font-size: 15.5px; margin: 0; font-weight: bold;">` + (that.choosemap.deviceOfflineCount || 0) + `</p>
</div>
<div style="width: 32%; margin-bottom: 10px;">
  <p style="color: white; font-size: 13px; margin: 0;">插口总数</p>
  <p style="color: #00e4fe; font-size: 15.5px; margin: 0; font-weight: bold;">` + (that.choosemap.devicePortCount || 0) + `</p>
</div>
<div style="width: 32%; margin-bottom: 10px;">
  <p style="color: white; font-size: 13px; margin: 0;">使用中</p>
  <p style="color: #00e4fe; font-size: 15.5px; margin: 0; font-weight: bold;">` + (that.choosemap.devicePortUsingCount || 0) + `</p>
</div>
<div style="width: 32%; margin-bottom: 10px;">
  <p style="color: white; font-size: 13px; margin: 0;">空闲中</p>
  <p style="color: #00e4fe; font-size: 15.5px; margin: 0; font-weight: bold;">` + (that.choosemap.devicePortIdleCount || 0) + `</p>
</div>
</div>` 
            // `<p style="color:white;font-size:14.5px;margin-bottom:0px">电话号码:` +
            // that.choosemap.devicePortUsingCount +
            // `</p>`
            ;
          infoWindow = new BMapGL.InfoWindow(sContent, opts);
          that.map.openInfoWindow(infoWindow, pt); // 开启信息窗口
        }, 500);
      });
   
    
    },
    getMapDataLngLat() {
      mapDataLngLat().then((res) => {
        console.log("mmmmm1", res);
        // this.mapMakers = res.data.offlineData;
        // this.alarmMakers = res.data.alarmData;
        // this.onlineMakers = res.data.onlineData;
        this.init();
      });
    },
    getInspectionRecord() {
      if (this.xj <= 50) {
        this.xjz = 1;
      } else if (this.xj >= 51 && this.xj <= 100) {
        this.xjz = 2;
      } else if (this.xj >= 101 && this.xj <= 500) {
        this.xjz = 5;
      } else if (this.xj >= 501 && this.xj <= 1000) {
        this.xjz = 15;
      } else if (this.xj >= 1001 && this.xj <= 3000) {
        this.xjz = 30;
      } else if (this.xj >= 3001 && this.xj <= 10000) {
        this.xjz = 60;
      }
      if (this.rw <= 50) {
        this.rwz = 1;
      } else if (this.rw >= 51 && this.rw <= 100) {
        this.rwz = 5;
      } else if (this.rw >= 101 && this.rw <= 500) {
        this.rwz = 10;
      } else if (this.rw >= 501 && this.rw <= 1000) {
        this.rwz = 15;
      }else if (this.rw >= 1001 && this.rw <= 3000) {
        this.rwz = 30;
      } else if (this.rw >= 3001 && this.rw <= 10000) {
        this.rwz = 60;
      }
      if (this.cs <= 50) {
        this.csz = 1;
      } else if (this.cs >= 51 && this.cs <= 100) {
        this.csz = 5;
      } else if (this.cs >= 101 && this.cs <= 500) {
        this.csz = 10;
      } else if (this.cs >= 501 && this.cs <= 1000) {
        this.csz = 15;
      }else if (this.cs >= 1001 && this.cs <= 3000) {
        this.csz = 30;
      } else if (this.cs >= 3001 && this.cs <= 10000) {
        this.csz = 60;
      } else if (this.cs >= 10001 && this.cs <= 20000) {
        this.csz = 130;
      } else if (this.cs >= 20001 && this.cs <= 30000) {
        this.csz = 200;
      }
      if (this.wc <= 50) {
        this.wcz = 1;
      } else if (this.wc >= 51 && this.wc <= 100) {
        this.wcz = 5;
      } else if (this.wc >= 101 && this.wc <= 500) {
        this.wcz = 10;
      } else if (this.wc >= 501 && this.wc <= 1000) {
        this.wcz = 15;
      }else if (this.wc >= 1001 && this.wc <= 3000) {
        this.wcz = 30;
      } else if (this.wc >= 3001 && this.wc <= 10000) {
        this.wcz = 80;
      } else if (this.wc >= 10001 && this.wc <= 20000) {
        this.wcz = 180;
      } else if (this.wc >= 20001 && this.wc <= 30000) {
        this.wcz = 300;
      }
    },
    getGeneral() {
      const Xdata = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
      const AlarmData = this.alarmData;
      console.log(this.alarmData);
      const Faultdata = this.faultdata;
      // for (let i = 0; i < this.alarmFaultNums.length; i++) {
      //   const item = this.alarmFaultNums[i];
      //   Xdata.push(item.date);
      //   AlarmData.push(item.alarmAmount);
      //   Faultdata.push(item.faultAmount);
      // }
      const chartBox = this.$echarts.init(
        document.querySelector(".general-situation")
      );
      const option = {
        tooltip: {
          transitionDuration: 0, //当鼠标移上去 会出现滚动条 设置这个属性就不会了
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#257ef4",
            },
          },
          // formatter: "项目地区分布 <br/>{b}: {}",
          backgroundColor: "#00b7b7",
          textStyle: {
            // 提示框浮层的文本样式
            color: "#fff",
          },
        },
        color: ["#4290fc", "#29faff"],
        grid: {
          left: "2%",
          right: "4%",
          bottom: "7%",
          top: "20%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: Xdata,
            axisLabel: {
              show: true,
              textStyle: {
                color: "#52a2c3",
              },
            },
            axisLine: {
              lineStyle: {
                color: "#225072",
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              show: true,
              textStyle: {
                color: "#52a2c3",
              },
            },
            splitLine: {
              lineStyle: {
                color: "#225072",
              },
            },
          },
        ],

        series: [
          {
            name: "报警数",
            type: "line",

            emphasis: {
              focus: "series",
            },
            data: AlarmData,
            symbolSize: 8,
            symbol: "circle",
            areaStyle: {
              color: {
                type: "linear",
                x: 0, //右
                y: 0, //下
                x2: 0, //左
                y2: 1, //上
                colorStops: [
                  {
                    offset: 0.1,
                    color: "#2bfbff", // 0% 处的颜色 设置渐变
                  },
                  {
                    offset: 1,
                    color: "#1b436630", // 100% 处的颜色 设置渐变
                  },
                ],
              },
            },
          },
          {
            name: "故障数",
            type: "line",
            emphasis: {
              focus: "series",
            },
            data: Faultdata,
            areaStyle: {
              color: {
                type: "linear",
                x: 0, //右
                y: 0, //下
                x2: 0, //左
                y2: 1, //上
                colorStops: [
                  {
                    offset: 0.1,
                    color: "#2778ad", // 0% 处的颜色 设置渐变
                  },
                  {
                    offset: 1,
                    color: "#28426530", // 100% 处的颜色 设置渐变
                  },
                ],
              },
            },
          },
        ],
      };
      chartBox.setOption(option);
      // 根据页面大小自动响应图表大小
      window.addEventListener("resize", function () {
        chartBox.resize();
      });
    },
    init() {
      let that = this;
      let map = new BMapGL.Map("container"); // 创建地图实例
      // let point = new BMapGL.Point(120.8003, 27.960936); 
      let point = new BMapGL.Point(119.929085, 31.742764); // 创建点坐标
      map.centerAndZoom(point, 11);
      map.enableScrollWheelZoom(true); //开启鼠标滚轮缩放
      map.setMapStyleV2({ styleId: "dec22c615920835d13a1b12a3a633a80" });
      map.setHeading(45); //设置地图旋转角度
      map.setTilt(45); //设置地图的倾斜角度

      //取消天空颜色
      map.setDisplayOptions({
        skyColors: ["rgba(186, 0, 255, 0)", "rgba(186, 0, 255, 0.0)"],
      });
      this.map = map;
      this.initMarkers();
    },
    initMarkers() {
        //在线
        var that = this;
        for (let i = 0; i < this.onlineMakers.length; i++) {
          console.log("this.onlineMakers[i]", this.onlineMakers[i]);
        let myIcon = "";
        if(this.onlineMakers[i].deviceOfflineCount>0){
          myIcon = new BMapGL.Icon(
          "../../static/image/home1_12.png",
            new BMapGL.Size(25, 35)
          );
        }else{
          myIcon = new BMapGL.Icon(
          "../../static/image/home1_11.png",
          new BMapGL.Size(20, 29)
        );
        }
       
        let pt = new BMapGL.Point(
          this.onlineMakers[i].lng,
          this.onlineMakers[i].lat
        );
        let marker = new BMapGL.Marker(pt, {
          icon: myIcon,
        });
        that.map.addOverlay(marker);
        let opts = {
          width: 450,
          height: 230,
        };
        let infoWindow = "";
        let sContent = ``;
        marker.addEventListener("click", function (e) {
        
          setTimeout(() => {
            console.log("123123123", that.choosemap);
            that.choosemap = that.onlineMakers[i];
            sContent =
            `<div><div style="font-weight:bold;font-size:13.5px;color:white;"><img
            style="width: 20px; float: left; margin-right: 10px" src="../../static/image/map1.png" alt=""/>` +
            `<span style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;color:white;display:inline-block;width:65%;font-size:15.5px">` +  
            that.choosemap.name +
            `</span>` +
            `<span style="float:right;margin-right:10px;font-size:15.5px">今日营收:` + 
            (that.choosemap.todayIncome === null ? '0元' : (that.choosemap.todayIncome/100).toFixed(1) + '元') + 
            `</span>` +
            `</div>` +
              `<p style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;color:white;">
                <img style="width: 18px; float: left;margin-right:5px" src="../../static/image/map2.png" alt=""/>` +
              that.choosemap.address +
              `</p>` +
              `<p style="color:white;font-size:15.5px;"> <img style="width: 18px; float: left;margin-right:5px" src="../../static/image/map5.png" alt=""/>设备统计</p>` +
              `<div style="display: flex; justify-content: space-between; flex-wrap: wrap; width: 99%;margin-left:1%">
  <div style="width: 32%; margin-bottom: 10px;">
    <p style="color: white; font-size: 13px; margin: 0;">设备总数</p>
    <p style="color: #00e4fe; font-size: 15.5px; margin: 0; font-weight: bold;">` + (that.choosemap.deviceCount || 0) + `</p>
  </div>
  <div style="width: 32%; margin-bottom: 10px;">
    <p style="color: white; font-size: 13px; margin: 0;">在线设备</p>
    <p style="color: #00e4fe; font-size: 15.5px; margin: 0; font-weight: bold;">` + (that.choosemap.deviceOnlineCount || 0) + `</p>
  </div>
  <div style="width: 32%; margin-bottom: 10px;">
    <p style="color: white; font-size: 13px; margin: 0;">离线设备</p>
    <p style="color: red; font-size: 15.5px; margin: 0; font-weight: bold;">` + (that.choosemap.deviceOfflineCount || 0) + `</p>
  </div>
  <div style="width: 32%; margin-bottom: 10px;">
    <p style="color: white; font-size: 13px; margin: 0;">插口总数</p>
    <p style="color: #00e4fe; font-size: 15.5px; margin: 0; font-weight: bold;">` + (that.choosemap.devicePortCount || 0) + `</p>
  </div>
  <div style="width: 32%; margin-bottom: 10px;">
    <p style="color: white; font-size: 13px; margin: 0;">使用中</p>
    <p style="color: #00e4fe; font-size: 15.5px; margin: 0; font-weight: bold;">` + (that.choosemap.devicePortUsingCount || 0) + `</p>
  </div>
  <div style="width: 32%; margin-bottom: 10px;">
    <p style="color: white; font-size: 13px; margin: 0;">空闲中</p>
    <p style="color: #00e4fe; font-size: 15.5px; margin: 0; font-weight: bold;">` + (that.choosemap.devicePortIdleCount || 0) + `</p>
  </div>
</div>` 
              // `<p style="color:white;font-size:14.5px;margin-bottom:0px">电话号码:` +
              // that.choosemap.devicePortUsingCount +
              // `</p>`
              ;
            infoWindow = new BMapGL.InfoWindow(sContent, opts);
            that.map.openInfoWindow(infoWindow, pt); // 开启信息窗口
          }, 500);
        });
     
      }
      //地图上的点-离线
    
      // for (let i = 0; i < this.mapMakers.length; i++) {
      //   let myIcon = "";
      //   myIcon = new BMapGL.Icon(
      //     "../../static/image/home1_11.png",
      //     new BMapGL.Size(20, 29)
      //   );
      //   let pt = new BMapGL.Point(
      //     this.mapMakers[i].projectLng,
      //     this.mapMakers[i].projectLat
      //   );
      //   let marker = new BMapGL.Marker(pt, {
      //     icon: myIcon,
      //   });
      //   that.map.addOverlay(marker);
      //   let opts = {
      //     width: 280,
      //     height: 160,
      //   };
      //   let infoWindow = "";
      //   let sContent = ``;
      //   marker.addEventListener("click", function (e) {
      //     that.getSelectTCProjectData(that.mapMakers[i].projectId);
      //     setTimeout(() => {
      //       console.log("123123123", that.choosemap);
      //       sContent =
      //         `<div><div style="font-weight:bold;font-size:13.5px;color:white"><img
      //               style="width: 20px; float: left; margin-right: 10px" src="../../static/image/home1_14.png" alt=""/><strong>项目名称:</strong>` +
      //         that.choosemap.fireProject.projectName +
      //         `</div>` +
      //         `<p style="color:white;font-size:13px;">项目ID:` +
      //         that.choosemap.fireProject.projectId +
      //         `</p>` +
      //         `<p style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;color:white;font-size:13px;">项目地址:` +
      //         that.choosemap.fireProject.projectAddress +
      //         `</p>` +
      //         `<p style="color:white;font-size:13px;">负责人:` +
      //         that.choosemap.fireProject.projectResponsibilityName +
      //         `</p>` +
      //         `<p style="color:white;font-size:13px;margin-bottom:0px">电话号码:` +
      //         that.choosemap.fireProject.projectResponsibilityPhone +
      //         `</p>`;
      //       infoWindow = new BMapGL.InfoWindow(sContent, opts);
      //       that.map.openInfoWindow(infoWindow, pt); // 开启信息窗口
      //     }, 800);
      //   });
      // }

      // for (let i = 0; i < this.alarmMakers.length; i++) {
      //   let myIcon = "";
      //   myIcon = new BMapGL.Icon(
      //     "../../static/image/home1_12.png",
      //     new BMapGL.Size(20, 29)
      //   );
      //   let pt = new BMapGL.Point(
      //     this.alarmMakers[i].projectLng,
      //     this.alarmMakers[i].projectLat
      //   );
      //   let marker = new BMapGL.Marker(pt, {
      //     icon: myIcon,
      //   });
      //   that.map.addOverlay(marker);
      //   let opts = {
      //     width: 280,
      //     height: 180,
      //   };
      //   let infoWindow = "";
      //   let sContent = ``;
      //   marker.addEventListener("click", function (e) {
      //     that.getSelectTCProjectData(that.mapMakers[i].projectId);
      //     setTimeout(() => {
      //       console.log("123123123", that.choosemap);
      //       sContent =
      //         `<div><div style="font-weight:bold;font-size:13.5px;color:white"><img
      //               style="width: 20px; float: left; margin-right: 10px" src="../../static/image/home1_15.png" alt=""/><strong>项目名称:</strong>` +
      //         that.choosemap.fireProject.projectName +
      //         `</div>` +
      //         `<p style="color:white;font-size:13px;">项目ID:` +
      //         that.choosemap.fireProject.projectId +
      //         `</p>` +
      //         `<p style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;color:white;font-size:13px;">项目地址:` +
      //         that.choosemap.fireProject.projectAddress +
      //         `</p>` +
      //         `<p style="color:white;font-size:13px;">负责人:` +
      //         that.choosemap.fireProject.projectResponsibilityName +
      //         `</p>` +
      //         `<p style="color:white;font-size:13px;margin-bottom:0px">电话号码:` +
      //         that.choosemap.fireProject.projectResponsibilityPhone +
      //         `</p>`;
      //       infoWindow = new BMapGL.InfoWindow(sContent, opts);
      //       that.map.openInfoWindow(infoWindow, pt); // 开启信息窗口
      //     }, 800);
      //   });
      // }
    
    },
    getSelectTCProjectData(projectId) {
      selectTCProjectData(projectId).then((res) => {
        this.choosemap = res.data;
        console.log(this.choosemap);
      });
    },
    closeMap() {
      var mapElement1 = document.querySelector(".map-info");
      mapElement1.style.display = "none";
    },
    closeMapDanger() {
      var mapDanger = document.querySelector(".map-info-danger");
      mapDanger.style.display = "none";
    },
    //跳转页面
    internet(path, path1) {
      this.$router.push({ path: "/" + path + "/" + path1 });
    },
    getAll(num1) {
      const xsNum=num1
      const num=Math.abs(num1)
      this.editForm = this.user;
      const chartBox = this.$echarts.init(
        document.querySelector(".body-R-all")
      );
      const option = {
        tooltip: {
          formatter: "{a} <br/>{b} : {c}%",
        },
        series: [
          {
            name: "Pressure",
            type: "gauge",
            axisLine: {
              lineStyle: {
                width: 10,
                color: [
                  [0.2, "#f8397f"],
                  [0.8, "#1f8dfc"],
                  [1, "#43e4f8"],
                ],
              },
            },
            radius: "100%",
            pointer: {
              itemStyle: {
                color: "auto",
              },
            },
            axisTick: {
              distance: 0,
              length: 8,
              lineStyle: {
                color: "#3ccee5",
                width: 1,
              },
            },
            axisLabel: {
              color: "#3ccee5",
              distance: 5,
              fontSize: 11,
            },
            splitLine: {
              distance: -10,
              length: 30,
              lineStyle: {
                color: "transparent",
                width: 4,
              },
            },
            title: {
              offsetCenter: [0, "62%"],
              color: "#fff",
              fontSize: 12,
            },
            detail: {
              formatter: xsNum+'%',
              color: "#41fd84",
              fontSize: 25,
              offsetCenter: [0, "90%"],
            },
            data: [
              {
                value: num,
                name: "升降率",
              },
            ],
          },
        ],
      };
      chartBox.setOption(option);
      // 根据页面大小自动响应图表大小
      window.addEventListener("resize", function () {
        chartBox.resize();
      });
    },
    mapReady({ BMap, map }) {
      this.point = new BMap.Point(120.7059, 28.000093);
      map.centerAndZoom(this.point, 15);
      map.setMapStyleV2({
        styleId: "dec22c615920835d13a1b12a3a633a80",
      });

      map.setHeading(45); //设置地图旋转角度
      map.setTilt(45);
    },

    start() {
      this.realTime = setInterval(this.getRealTime, 1000); // 注意: 第一个参数为方法名的时候不要加括号;
    },
    getRealTime() {
      var time = new Date();
      var year = time.getFullYear();
      //年
      var month = time.getMonth() + 1;
      //月
      var date = time.getDate();
      //几号
      var day = time.getDay();
      //星期几
      var arr = [
        "星期天",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
      ];

      var hour = time.getHours();
      //小时
      var minutes = time.getMinutes();
      //分钟
      var second = time.getSeconds();
      //秒
      this.realTime1 = year + "年" + month + "月" + date + "日 " + arr[day];
      this.realTime2 = hour + ":" + minutes + ":" + second;
    },
    forWardPath(path, sorue) {
      this.$router.push({ path: "/" + path + "?sorue=" + sorue });
    },
    editPassword() {
      this.addFormInline.userId = this.editForm.userId;
      editPassword(this.addFormInline).then((res) => {
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: "密码更改成功，重新登录!",
          });
          this.editFormVisible02 = false;
          localStorage.clear();
          this.$store.commit("logout", "false");
          this.$router.push({ path: "/login" });
        } else {
          this.loading = false;
          this.$message.error(res.msg);
        }
      });
    },

    //显示界面
    handleEdit: function () {
      this.editFormVisible = true;
      this.editForm = this.user;
    },
    // 退出登录
    exit() {
      this.$confirm("退出登录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          setTimeout(() => {
            localStorage.clear();
            this.$store.commit("logout", "false");
            this.$router.push({ path: "/login" });

            this.$message({
              type: "success",
              message: "已退出登录!",
            });
          }, 1000);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false;
      this.$refs[formName].resetFields();
    },
    eqit() {
      this.$router.push({ path: "/data-overview" });
    },
    //显示界面
    handleEdit02: function () {
      this.editFormVisible02 = true;
    },
    // 关闭编辑、增加弹出框
    closeDialog02() {
      this.editFormVisible02 = false;
    },
  },
};
</script>
<style>
.searchPro .el-message-box {
  width: 30%;
}
.searchPro .el-select-dropdown__list {
  background: #021132;
  border: 1px solid #00558c;
  font-size: 12px;
}
.BMap_bubble_pop {
  z-index: 9999 !important;
  /* top: 133px !important; */
  background: #12223c !important;
  border: 2px solid #1494dd;
  box-shadow: 0px 0px 5px #00558c !important;
  /* color: white !important; */
}
.BMap_bubble_content {
  line-height: 21px !important;
}
.BMap_bubble_center {
  top: -21px !important;
}
.BMap_bubble_buttons div div {
  top: 10px !important;
}
.userdetails .el-dialog__header {
  background: red;
}
</style>

<style scoped>
.heardT {
  position: absolute;
  z-index: 999;
  width: 100%;
  height: 76px;
  background-image: url("../../static/image/home1_1.png");
  background-size: 100% 100%;
}
.heardT-left{
  display: inline-block;
  color: #00e4ff;
  font-size: 1.8rem;
  font-weight: bold;
  font-family:'微软雅黑';
  position: relative;
  top:0.5rem;
  width: 20%;
  letter-spacing: 5px;
  /* line-height: 76px; */
  /* margin-top: 15px; */
  margin-left: 1.2rem;
}
.heardT-center {
  margin-left: 6%;
  display: inline-block;
  height: 40px;
  width: 50%;
}

.heardT-right {
  height: 32px;
  float: right;
  margin-top: 5px;
  margin-right: 10.5px;
  color: #00a4eb;
}

.heardT-right span {
  position: relative;
  top: -0.2rem;
}

.T-center-input {
  width: 25%;
  margin-left: 27%;
  margin-top: 4px;
}
.el-select-dropdown__list {
  background: #021132;
  color: white;
  border: 1px solid #00558c;
  font-size: 12px;
}

.el-select-dropdown__item {
  font-size: 12px;
  padding: 0 8px;
  color: white;
}

.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  background: #026aaf;
  color: white;
}
.T-center-input >>> .el-input__inner {
  width: 100%;
  height: 32px;
  border: none;
  color: white;
  font-size: 13px;
  background: transparent url("../../static/image/home1_2.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.T-center-input >>> .el-input__icon {
  line-height: 32px;
  margin-right: 4px;
}

.heardT ul {
  padding: 0px;
  margin: 0px;
  list-style-type: none;
  color: #01649b;
  font-size: 15px;
  background: red;
}

.heardT li {
  float: left;
  margin-top: 8px;
}

.heardT li span {
  margin-left: 24px;
  margin-right: 24px;
}

.heardT li:hover {
  background-image: url("../../static/image/home1_3.png");
  background-repeat: no-repeat;
  height: 30px;
  background-size: 80%;
  cursor: pointer;
  background-position: 5px bottom;
}

.heardT span:hover {
  color: #00e4fe;
}

.on {
  background-image: url("../../static/image/home1_3.png");
  background-repeat: no-repeat;
  height: 30px;
  background-size: 80%;
  cursor: pointer;
  background-position: 5px bottom;
}

.bodyRight {
  position: absolute;
  z-index: 999;
  top: 4.5rem;
  right: 12px;
  width: 34vh;
  padding: 2vh;
  border: 0px solid;
  background-image: url("../../static/image/home1_6.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  height: 52vh;
}

.body-R-num {
  width: 95%;
  margin: auto;
  display: flex;
  justify-content: space-between;
}

.body-R-num div {
  width: 47%;
  background-image: url("../../static/image/home1_7.png");
  background-repeat: no-repeat;
  height: 9vh;
  background-size: 100% 100%;
  line-height: 1.5vh;
  display: inline-block;
}

.body-R-num p {
  text-align: center;
}

.body-R-num p:nth-child(1) {
  font-size: 1.6vh;
}

.body-R-num p:nth-child(2) {
  font-size: 2.6vh;
  color: #00fff1;
  font-weight: bold;
  margin-top: 2.8vh;
  /* padding-top: -2vh; */
}

.body-R-all {
  width: 100%;
  margin: 2vh auto 0px;
  height: 21vh;
}

.body-R-percentage {
  display: flex;
  flex-wrap: wrap;
  margin-top: 1.5vh;
  /* justify-content: space-around; */
}

.body-R-percentage > div {
  line-height: 0px;
  width: 45%;
  font-size: 1.6vh;
  margin-right: 5%;
  margin-bottom: 1vh;
}

.body-R-percentage > div span:nth-child(2) {
  float: right;
}

.bodyRight >>> .el-progress-bar__outer {
  background: rgba(214, 214, 214, 0.2);
  border: 1px solid #2a5987;
  width: 100%;
}

.bodyRight >>> .el-progress-bar__inner:nth-child(1) {
  background: black;
  /* height: 0.2rem; */
  /* border: 2px solid #caf426; */
}

.bodyLeft {
  position: absolute;
  z-index: 999;
  top: 4.5rem;
  left: 12px;
  width: 18vh;
  border: 0px solid;
}

.bodyLeft div {
  width: 100%;
  height: 11vh;
  background-image: url("../../static/image/home1_5.png");
  background-size: 100% 100%;
  text-align: center;
  line-height: 0.2rem;
  margin-top: -12px;
}

.bodyLeft div p:nth-of-type(1) {
  color: #c6ec1c;
  font-size: 3.2vh;
  padding-top: 3.5vh;
  font-weight: bold;
  font-family: "Gill Sans", "Gill Sans MT", Calibri, "Trebuchet MS", sans-serif;
}

.bodyLeft div p:nth-of-type(2) {
  font-size: 1.6vh;
}

.bottomT {
  position: absolute;
  z-index: 999;
  left: 12px;
  right: 12px;
  height: 30vh;
  /* background: #00558c; */
  bottom: 10px;
}

.bottom-general-situation {
  width: 35%;
  height: 30vh;
  background-image: url("../../static/image/home1_8.png");
  background-size: 100% 100%;
  float: left;
}

.bottom-general-situation > span {
  margin-left: 3%;
  margin-top: 1.35%;
  font-size: 1.8vh;
  display: inline-block;
}

.bottom-general-situation-div {
  float: right;
  color: white;
  font-size: 14px;
  margin-right: 24px;
  padding-top: 8px;
  /* background: #02fea7; */
  margin-top:2vh;
}

.bottom-general-situation li {
  float: left;
  list-style-type: none;
  margin-left: 12px;
  cursor: pointer;
}

.bottom-general-situation .active {
  color: #00a4eb;
  font-weight: bold;
  font-size: 15px;
}

/* 物管考评 */
.bottom-property-management {
  width: 35%;
  height: 30vh;
  background-image: url("../../static/image/home1_8.png");
  background-size: 100% 100%;
  margin-left: 1%;
  float: left;
}

.bottom-property-management > span {
  margin-left: 3%;
  margin-top: 1.35%;
  font-size: 1.8vh;
  display: inline-block;
}

.management-title {
  float: right;
  color: white;
  font-size: 14px;
  margin-right: 21.5px;
  padding-top: 1.3vh;
}

.management-title li {
  float: left;
  list-style-type: none;
  margin-left: 12px;
  cursor: pointer;
}

.management-title .active {
  color: #00a4eb;
  font-weight: bold;
}

.routing-inspection {
  height: 7.4vh;
  margin-bottom: -2vh;
  display: flex;
  justify-content: space-between;
}


.routing-inspection li {
  list-style-type: none;
  float: left;
}
.bars-container {
  width: 75%; /* 父容器宽度为 80% */
  display: flex;
  justify-content: space-between; /* 平均分配 */
  align-items: center;

  padding: 0px 0; /* 可选：增加内边距 */
  height: 1.6vh;
}

.bar {
  height: 1.6vh;
  width: calc(100% / 90 - 2px); /* 计算宽度（减去可能的间隙） */
  background-color: #42b983; /* 小长条颜色 */
  margin: 0 1px; /* 可选：增加间距 */
}

.bottom-property-management p {
  font-size: 0.7rem;
  margin-left: 21.5px;
  /* background:red; */
  height: 1.6vh;
  margin-top: 15px;

  /* margin-top: 20px; */
  color: white;
}

.inspection-number {
  width: 5rem;
  display: inline-block;
  text-align: center;
  color: #33ecff;
  font-weight: bold;
  font-family: "Gill Sans", "Gill Sans MT", Calibri, "Trebuchet MS", sans-serif;
  font-size: 26px;
  position: relative;
  top: 0.5vh;
}

.inspection-percentage {
  width: 72px;
  display: inline-block;
  text-align: center;
  color: #02fea7;
  font-weight: bold;
  font-family: "Gill Sans", "Gill Sans MT", Calibri, "Trebuchet MS", sans-serif;
  font-size: 26px;
  position: relative;
  top: -1.4vh;
}

.inspection-rise {
  width: 40px;
  display: inline-block;
  text-align: center;
  color: #02fea7;
  font-weight: bold;
  font-family: "Gill Sans", "Gill Sans MT", Calibri, "Trebuchet MS", sans-serif;
  font-size: 24px;
  position: relative;
  top: -1.35vh;
}

.grid-cell {
  width: 0.75%;
  height: 1.6vh;
  background: rgba(66, 89, 120, 0.4);
  margin-right: 0.15rem;
}

.general-situation {
  width: 95%;
  margin: auto;
  height: 25vh;
  /* background: #00558c; */
  margin-top: 15px;
  /* background: #00558c; */
}

/* 实时告警 */
.alarm {
  width: 28%;
  height: 30vh;
  background-image: url("../../static/image/home1_9.png");
  background-size: 100% 100%;
  float: right;
}

.alarm > span {
  margin-left: 2.5%;
  margin-top: 1.35%;
  font-size: 1.8vh;
  display: inline-block;
}

.alarm-list {
  width: 100%;
  height: 24vh;
  overflow: auto;
  position: relative;
  top: -10px;

}

.alarm-list ul {
  list-style-type: none;
  padding: 0%;
  color: rgba(255, 255, 255, 0.85);
  /* margin-left: -0.28rem; */
  font-size: 16px;

}
::-webkit-scrollbar {
  width: 8px;
  margin-left: 5px;
}

::-webkit-scrollbar-thumb {
  background-color: #1d6e89;
  border-radius: 10px;
}
.alarm-list ul img {
  width: 20px;
  height: 20px;
  float: left;
  margin-left: 1.5vh;
}

.alarm-list li {
  padding-bottom: 10px;
  border-bottom: 1px dashed rgba(12, 86, 111, 0.7);
  margin-bottom: 12px;
  width: 95%;
  box-sizing: border-box;
}

.alarm-list li span:nth-of-type(1) {
  margin-right: 5px;
  margin-left: 1.3vh;
  font-size: 19px;
  font-weight: bold;
  width: 10%;
  display: inline-block;
  color: rgba(171, 220, 237, 0.8);
}

.alarm-list li span:nth-of-type(2) {
  margin-left: 10px;
  white-space: nowrap;      /* 禁止换行 */
  overflow: hidden;         /* 隐藏溢出内容 */
  text-overflow: ellipsis;  /* 超出部分显示省略号 */
}
.alarm-list li span:nth-of-type(3) {
  float: right;
}

.map-info {
  position: absolute;
  z-index: 100001;
  width: 240px;
  height: 168px;
  padding: 16px;
  background-image: url("../../static/image/home1_13.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  display: none;
}

.map-info > p {
  margin-top: 0rem;
  margin-bottom: 16px;
  color: #019fe9;
  font-size: 14.5px;
  font-weight: bold;
}
.map-info > p span {
  width: 82%;
  height: 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
}
.map-info > div {
  font-size: 14.5px;
  margin-top: 8px;
}

.map-info > div p {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.map-info-danger {
  position: absolute;
  z-index: 100001;
  width: 270px;
  padding: 16px;
  left: 0rem;
  top: 0rem;
  background-image: url("../../static/image/home1_15.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  height: 52px;
  display: none;
}

.map-info-danger > div {
  margin-top: -8px;
  line-height: 14.5px;
  line-height: 14px;
}

.map-info-danger > div p:nth-of-type(1) {
  width: 80%;
  font-size: 14px;
  margin-left: 19%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.map-info-danger > div p:nth-of-type(2) {
  width: 80%;
  font-size: 14px;
  margin-left: 19%;
}
.projectSarchList {
  width: 25%;
  margin-left: 27%;
  margin-top: 4px;
  border-radius: 8px;
  background: #021132;
  border: 1px solid #00558c;

  font-size: 12.5px;
}
.projectList5 {
  height: 240px;
  overflow: auto;
}
.projectSarchList p {
  padding: 2% 4%;
}
.projectSarchList p:hover {
  background: #026aaf;
  color: white;
}
.projectSarchList::-webkit-scrollbar {
  width: 6px;
  position: relative;
  left: 10px;
  margin-left: 5px;
}
.projectSarchList::-webkit-scrollbar-thumb {
  background-color: #1d6e89;
  border-radius: 10px;
}
/* 个人中心 */
.details-left {
  width: 80%;
  display: inline-block;
  /* height: 300px; */
  margin-left: 20px;
  border: 2px dashed rgb(230, 230, 230);
}
.details-left div {
  border-bottom: 2px dashed rgb(230, 230, 230);
  font-size: 16px;
  color: black;
  /* padding:20px 0 ; */
}
.details-left span {
  border-right: 2px dashed rgb(230, 230, 230);
}
.details-left span:nth-child(odd) {
  display: inline-block;
  width: 15%;
  text-align: center;
  padding: 20px;
}
.details-left span:nth-child(even) {
  display: inline-block;
  width: 26%;
  /* text-align: center; */
  padding: 20px;
}
</style>




// WEBPACK FOOTER //
// src/views/map.vue